import { z } from 'zod';

export const pricingConfigMachineSchema = z.object({
  id: z.string().optional(),
  code: z.string().min(1, 'Mã máy không được để trống'),
  name: z.string().min(1, 'Tên máy không được để trống'),
  maxSheetWidth: z.number().min(0),
  maxSheetLength: z.number().min(0),
  baseBatchSize: z.number().int().min(1),
  cmykBatchCost: z.number().min(0),
  cmykRunOnCost: z.number().min(0),
  spotColorCostMultiplier: z.number().min(0).default(2.0),
  uvInkCostMultiplier: z.number().min(0).default(3.0),
  plateCost: z.number().min(0).default(0),
  makeReadyCost: z.number().min(0).default(0),
  washUpCostSpotColor: z.number().min(0).default(0),
  status: z.string().default('ACTIVE'),
});

export type PricingConfigMachineForm = z.infer<typeof pricingConfigMachineSchema>;

export const pricingConfigProcessSchema = z.object({
  id: z.string().optional(),
  code: z.string().min(1, 'Mã công đoạn không được để trống'),
  name: z.string().min(1, 'Tên công đoạn không được để trống'),
  type: z.string().min(1, 'Loại công đoạn không được để trống'),
  minBatchCost: z.number().min(0),
  unitCost: z.number().min(0),
  unitType: z.string().min(1, 'Đơn vị tính không được để trống'),
  moldPricingType: z.string().optional().default('FIXED'),
  baseMoldPrice: z.number().nullable().optional(),
  moldFormula: z.string().nullable().optional(),
  moldFixedCost: z.number().min(0).default(0),
  status: z.string().default('ACTIVE'),
});

export type PricingConfigProcessForm = z.infer<typeof pricingConfigProcessSchema>;

export const pricingConfigWastageSchema = z.object({
  id: z.string().optional(),
  processType: z.string().min(1, 'Loại công đoạn không được để trống'),
  minQty: z.number().int().min(0),
  maxQty: z.number().int().min(0),
  setupWasteSheets: z.number().int().min(0),
  runWastePercent: z.number().min(0),
});

export type PricingConfigWastageForm = z.infer<typeof pricingConfigWastageSchema>;
